import React from "react";

import ChatInterface from "../../Components/ChatInterface";

const Home: React.FC = () => {
  return (
    <>
      <div>
        <div className="overflow-hidden sm:fixed inset-0 flex flex-col items-center justify-center bg-black bg-opacity-60 z-50 h-max sm:h-auto">
          <div className="w-[22rem] xs:w-[25rem] h-[723px] sm:w-[31.625rem] sm:min-h-[45.188rem] p-[1rem] sm:p-[1.5rem] pb-[3rem] bg-gradient-to-b from-bg to-white rounded-3xl">
            <ChatInterface />
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;
